module.exports = __webpack_public_path__ + "img/giveActive.c175c9d5.svg";